import {
	BrandName,
	CardContainer,
	CardContent,
	CardContentContainerMobile,
	CardTop,
	MobileLink,
	ProductName,
} from './productCard.styled';
import { useACF } from '@context/ACFContext';
import { Separator, HortizontalSeparator } from './separator/separator.styled';
import { Button } from '@components/core/button/Button';
import { PostTemplate, MainProduct } from 'types/globalTypes';
import RatingList from './ratingList/RatingList';
import FeatureList from './featureList/FeatureList';
import ProsCheckmark from '@assets/icons/ProsCheckmark';
import ConsCross from '@assets/icons/ConsCross';
import DiscountLabel from './discountLabel/DiscountLabel';
import LovedLabel from './lovedLabel/LovedLabel';
import TrustRating from './trustRating/TrustRating';
import parse from 'html-react-parser';
import CardBadge from '@assets/icons/CardBadge';
import ProductImage from './productImage/ProductImage';

const ProductCardMobile: React.FC = () => {
	const { postTemplate } = useACF() as { postTemplate?: PostTemplate };
	const main = postTemplate?.review_page_v4_products_section_settings.main_product;

	if (!postTemplate) return null;

	const mainProduct: MainProduct | undefined = postTemplate.review_page_v4_products_section_settings?.main_product;
	if (!mainProduct) return null;

	const {
		product_name,
		product_pros,
		product_cons,
		tr_best_choice_label,
		tr_cons_label,
		tr_pros_label,
		rating_bar_color,
		rating_bar_background_color,
		card_border_color,
	} = mainProduct;

	const {
		trust_pilot_rating_image,
		tr_trust_pilot_review_score_label,
		tr_trust_pilot_excellent_label,
		tr_trust_pilot_customer_reviews_label,
		trust_pilot_rating_score,
	} = mainProduct.trustpilot_component;

	const {
		tr_discount_component_discount_text,
		discount_component_discount_label_background,
		discount_component_discount_label_text_color,
	} = mainProduct.discount_component;

	const { tr_button_text, button_cta_link } = mainProduct.button_component;

	if (!main) return null;

	return (
		<CardContainer $withShadow={true} $borderColor={card_border_color}>
			<CardTop $linkColor={'#0060C3'}>
				<ProductName>{`1. ${product_name}`}</ProductName>
				<BrandName>{parse(tr_best_choice_label)}</BrandName>
				<CardBadge />
			</CardTop>
			<CardContent>
				<CardContentContainerMobile>
					<ProductImage productImage={main.product_image} />
					<Separator $height="100%" $spacing="7px" />
					<TrustRating
						reviewLabel={tr_trust_pilot_review_score_label}
						reviewScore={trust_pilot_rating_score}
						reviewEvaluation={tr_trust_pilot_excellent_label}
						reviewCount={tr_trust_pilot_customer_reviews_label}
						reviewImage={trust_pilot_rating_image}
					/>
				</CardContentContainerMobile>
				<div style={{ marginTop: '16px' }}>
					<DiscountLabel
						text={tr_discount_component_discount_text}
						$textColor={discount_component_discount_label_text_color}
						$backgroundColor={discount_component_discount_label_background}
					/>
					<Button
						href={button_cta_link.url}
						target={button_cta_link?.target === '_blank' ? '_blank' : '_self'}
						primary={true}
					>
						{tr_button_text}
					</Button>
					<LovedLabel />
				</div>
				<HortizontalSeparator $width="100%" />
				<RatingList
					$barBackground={rating_bar_background_color}
					$barColor={rating_bar_color}
					ratingRepeater={main.rating_repeater}
					prosRepeater={main.product_pros}
					consRepeater={main.product_cons}
					reviewScoreLabel={main.tr_review_score_label}
				/>
				<HortizontalSeparator $width="100%" />
				<FeatureList
					data={product_pros && product_pros?.map((item) => ({ label: item.tr_product_pro }))}
					title={tr_pros_label}
					icon={<ProsCheckmark />}
					color="#00a871"
				/>
				<HortizontalSeparator $width="100%" />
				<FeatureList
					data={product_cons && product_cons?.map((item) => ({ label: item.tr_product_con }))}
					title={tr_cons_label}
					icon={<ConsCross />}
					color="#D2152D"
				/>
				<HortizontalSeparator $width="100%" />
				<Button
					href={button_cta_link.url}
					target={button_cta_link?.target === '_blank' ? '_blank' : '_self'}
					primary={true}
				>
					{tr_button_text}
				</Button>
				<MobileLink href="#product-info">Read Full Product Review</MobileLink>
			</CardContent>
		</CardContainer>
	);
};

export default ProductCardMobile;
